import { Link } from "react-router-dom";
import { cn } from "@/lib/cn";

/**
 * StaxED brand mark. Uses the favicon (the actual StaxED logo asset shared
 * with staxed.in) so the marketing site and the app open with the exact
 * same mark.
 */
export function Brand({
  className,
  to = "/",
  showWordmark = true,
  size = "md",
}: {
  className?: string;
  to?: string;
  showWordmark?: boolean;
  size?: "sm" | "md" | "lg";
}) {
  const dim =
    size === "sm" ? "h-7 w-7" : size === "lg" ? "h-10 w-10" : "h-8 w-8";
  const wordmarkClass =
    size === "sm" ? "text-base" : size === "lg" ? "text-xl" : "text-lg";

  return (
    <Link
      to={to}
      className={cn(
        "inline-flex items-center gap-2 rounded-md text-text",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
        className,
      )}
      aria-label="StaxED home"
    >
      <img
        src="/favicon.png"
        alt=""
        aria-hidden
        className={cn("block flex-shrink-0", dim)}
        draggable={false}
      />
      {showWordmark ? (
        <span className={cn("font-display font-semibold tracking-tight", wordmarkClass)}>
          StaxED
        </span>
      ) : null}
    </Link>
  );
}
